import { render, staticRenderFns } from "./GlobalAssetItem.vue?vue&type=template&id=77da95cc"
import script from "./GlobalAssetItem.vue?vue&type=script&lang=js"
export * from "./GlobalAssetItem.vue?vue&type=script&lang=js"
import style0 from "./GlobalAssetItem.vue?vue&type=style&index=0&id=77da95cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports